import React, { useState, useEffect } from "react";
import { Table, Button, Col, message, Popconfirm, Row, Tooltip, Form , Tabs} from "antd";
import {components,GetLoggedInUser,getRowClassName,
} from "../../utils/utils";
import { usePermission } from "../../hooks/usePermission";
import { SearchOutlined } from '@ant-design/icons';
import { Space, Input, notification, Switch, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import CategoryRequest from "./CategoryRequest";
import IMAGES from "../../const/Image";
import dayjs from 'dayjs';
import { title } from "process";
const { Search } = Input;
const { confirm } = Modal;
const { TabPane } = Tabs;





const initialFilter = {
  page: 1,
};

const Categories = () => {

   const hasListPermission = usePermission("Categories", "List");
    const hasAddPermission = usePermission("Categories", "Add");
    const hasEditPermission = usePermission("Categories", "Edit");
    const hasDeletePermission = usePermission("Categories", "Delete");

  const [loading, setLoading] = useState(false);
  const [labList, setLabList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterForm, setFilterForm] = useState({});
  const [filter, setFilter] = useState(initialFilter);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  let LOG_IN_USER = GetLoggedInUser();

  const fetchCategoryList = () => {

    setLoading(true);
    CategoryRequest.categoryList(filter)
      .then((response) => {
        const rawData = response?.data?.data?.data || [];
        console.log(rawData)
        const totalCount = response?.data?.total || 0;
        setLabList(rawData);
        setFilteredCategories(rawData);
        setTotalRecords(totalCount);
      })
      .catch((error) => {
      
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };


  useEffect(() => {
    fetchCategoryList();
  }, [filter]);

  const handleChange = (pagination) => {
    setFilter({
      ...filter,
      page: pagination?.current,
    });
  };

  const handleFilter = (value) => {
    setFilter({ ...filter, ...filterForm, ...initialFilter })
    console.log('filter', filter)
    setIsModalOpen(false)
  }
  const resetFilters = () => {
    form.resetFields();
    setFilterForm({});
    setFilter(initialFilter);
  };

  const handleTabChange = (key) => {
    setFilter({ ...filter, gender: key === "all" ? null : key === "male" ? 0 : 1 });
  };

  const handleStatusChange = (checked, item) => {
    confirm({
      title: `Are you sure you want to ${checked ? "activate" : "deactivate"} this category?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        setLoading(true);
        let updateCategory = checked ? ("1") : ("0")
        
        CategoryRequest.updateCategory({
          status: updateCategory,
          id: item.id,
          categoryTitle: item.title,
        })
          .then((res) => {
            if (res && res.status === 200) {
              notification.success({
                message: "Status updated successfully",
              });
              setLabList((prevList) =>
                prevList.map((el) =>
                  el.id === item.id ? { ...el, is_active: checked ? "1" : "0" } : el
                )
              );
              fetchCategoryList();
            } else {
              notification.error({
                message: "Failed to update status",
              });
            }
          })
          .catch(() => {
            notification.error({
              message: "Failed to update status",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      },
    });
  };

  const columns = [
    {
      title: "S No.",
      dataIndex: "id",
      key: "id",
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: 100,
      render: (text, record) => (
        <a
          onClick={() => navigate(`/categories/view/${record.id}`)}
          style={{ color: "#1890ff", cursor: "pointer", fontSize: "17px" }}
        >
          {text}
        </a>
      ),
    },
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      width: 120,
      render: (text) => (
        <img
          src={text || IMAGES.PlaceholderImage}
          alt="Category"
          style={{ width: "100%", height: "66px" }}
        />
      ),
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      width: 100,
      render: (gender) => (
        gender === 0 ? "Male" : gender === 1 ? "Female" : "Unisex"
      )
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 120,
      align: "center",
      render: (is_active, item) => (
        <Switch
          checked={is_active === 1}
          checkedChildren="Active"
          unCheckedChildren="Inactive"
          onChange={(checked) => handleStatusChange(checked, item)}
        />
      ),
    },
    {
      title: "Created By",
      dataIndex: "createdBy",
      key: "createdBy",
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => dayjs(createdAt).format("MMMM D, YYYY h:mm:ss A"),
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (createdAt) => dayjs(createdAt).format("MMMM D, YYYY h:mm:ss A"),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title="View Details">
            <span
              className="action-icon-bg"
              onClick={() => navigate(`/categories/view/${record.id}`)}
            >
              <img src={IMAGES.ViewIcon} alt="View" />
            </span>
          </Tooltip>


          {/* <Tooltip title="Edit Details">
            <span
              className="action-icon-bg"
              onClick={() => navigate(`/categories/edit/${record.id}`)}
            >
              <img src={IMAGES.EditIcon} alt="Edit" />
            </span>
          </Tooltip>
           
          <Popconfirm
            title="Delete this category?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <span className="action-icon-bg">
              <img src={IMAGES.DeleteIcon} alt="Delete" />
            </span>
          </Popconfirm> */}

           {hasEditPermission && (
                        <Tooltip title="Edit Details">
                            <span
                                className="action-icon-bg"
                                onClick={() => navigate(`/categories/edit/${record.id}`)}
                            >
                                <img src={IMAGES.EditIcon} alt="Edit" />
                            </span>
                        </Tooltip>
                    )}

                    {hasDeletePermission && (
                        <Popconfirm
                            title="Delete this category?"
                            onConfirm={() => handleDelete(record.id)}
                            okText="Yes"
                            cancelText="No"
                        >
                            <span className="action-icon-bg">
                                <img src={IMAGES.DeleteIcon} alt="Delete" />
                            </span>
                        </Popconfirm>
                    )}
                
        </Space>
      ),
    },
  ];

  const handleDelete = (id) => {
    setLoading(true);
    CategoryRequest.deleteCategory(id)
      .then(() => {
        message.success("Category deleted successfully");
        setLabList((prevList) => prevList.filter((item) => item.id !== id));
        navigate(0, { state: { refresh: true } });
      })
      .catch((error) => {
        message.error("Failed to delete category");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // if (!hasListPermission) {
  //   return null; // Or show an "Access Denied" message
  // }

  return (
    <>
      <Row gutter={[8, 8]} justify="space-between" align="middle" style={{ marginBottom: "2rem" }} >
        <Col>
          <h1 className="app-heading-med">Category List</h1>
        </Col>

        <Col>

          <div style={{ display: "flex", gap: "1rem" }}>
            <Input
              placeholder="Search by title"
              size="large"
              className="FilterSearchBox"
              onChange={(e) => setFilterForm({ ...filterForm, search: e.target.value })}
              value={filterForm?.search}

              style={{ width: "100%" }}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleFilter();
                }
              }}

            />
    
            <Button
              onClick={handleFilter}
              type="primary"
              htmlType="submit"
              className="addcity-btn"
              style={{ height: "39px" }}
            >
              <SearchOutlined />
            </Button>
         
            <Button

              type="primary"
              className="addcity-btn"
              onClick={resetFilters}
              style={{ height: "39px" }}
            >
              Reset
            </Button>

            {/* <Button
              onClick={() => navigate("/categories/add")}
              type="primary"
              className="addcity-btn"
              style={{ height: "39px" }}
            >
              <img src={IMAGES.AddIconFilters} alt="Add" />
            </Button> */}

            {hasAddPermission && (
                            <Button
                                onClick={() => navigate("/categories/add")}
                                type="primary"
                                className="addcity-btn"
                                style={{ height: "39px" }}
                            >
                                <img src={IMAGES.AddIconFilters} alt="Add" />
                            </Button>
                        )}
                        
          </div>
        </Col>

      </Row>



<Tabs defaultActiveKey="Male" onChange={handleTabChange}  >
        {/* <TabPane tab="All" key="all">
          <Table
            size="middle"
            bordered
            columns={columns}
            loading={loading}
            rowKey={(record) => record.id}
            onChange={handleChange}
            dataSource={labList}
            pagination={{
              total: totalRecords,
              current: filter?.page || 1,
              defaultCurrent: 1,
            }}
          />
        </TabPane> */}
        <TabPane tab="Male" key="male">
          <Table
            size="middle"
            bordered
            columns={columns}
            loading={loading}
            rowKey={(record) => record.id}
            onChange={handleChange}
            dataSource={labList.filter((item) => item.gender === 0)}
            pagination={{
              total: totalRecords,
              current: filter?.page || 1,
              defaultCurrent: 1,
            }}
          />
        </TabPane>
        <TabPane tab="Female" key="female" >
          <Table
            size="middle"
            bordered
            columns={columns}
            loading={loading}
            rowKey={(record) => record.id}
            onChange={handleChange}
            dataSource={labList.filter((item) => item.gender === 1)}
            pagination={{
              total: totalRecords,
              current: filter?.page || 1,
              defaultCurrent: 1,
            }}
          />
        </TabPane>
      </Tabs>
    </>
  );
};

export default Categories;
